export class HiddenSubjectsDefinitions {
 public static subjects: string[] = ['VÅR', // vård och omsorg
  'MED', // medicin
    'NÄT', // näthandel
    'SJU', // sjukvård
    'TEN', // teknik i vård och omsorg
    'ITI', // IT i vård och omsorg//
  ];
}
